import { render, staticRenderFns } from "./ApprovalTimeOff.vue?vue&type=template&id=383b80cb&"
import script from "./ApprovalTimeOff.vue?vue&type=script&lang=js&"
export * from "./ApprovalTimeOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports